import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Ruler, FileSignature, DoorOpen } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

const ICONS = [Ruler, FileSignature, DoorOpen];

const Step = ({ s, i }) => {
  const Icon = ICONS[i];
  return (
    <Reveal delay={i * 0.1}>
      <div data-testid={`step-${i + 1}`} className="group grid grid-cols-[auto_1fr] gap-5 border-t border-white/15 py-8 sm:gap-8">
        <span className="font-display text-5xl font-extrabold leading-none text-[#F26D5A] sm:text-7xl">0{i + 1}</span>
        <div>
          <div className="flex items-center gap-3">
            <Icon className="h-5 w-5 text-[#F7D048] transition-transform duration-500 group-hover:-rotate-12" />
            <h3 className="font-display text-xl font-extrabold text-[#FDFBF7] sm:text-2xl">{s.t}</h3>
          </div>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-[#D9D2C8] sm:text-base">{s.d}</p>
        </div>
      </div>
    </Reveal>
  );
};

export const Steps = () => {
  const ref = useRef(null);
  const { t: all } = useLang();
  const t = all.steps;
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="com-funciona" ref={ref} data-testid="steps-section" className="grain relative overflow-hidden bg-[#232323] py-24 sm:py-32">
      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[28px]">
            <motion.img
              src="/images/phone.jpg"
              alt={t.alt}
              loading="lazy"
              style={{ y, scale: 1.25 }}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="spotlight absolute inset-0" />
            <p className="absolute bottom-5 left-5 rounded-full bg-[#F7D048] px-4 py-2 text-xs font-extrabold uppercase tracking-widest text-[#2D2D2D]">
              {t.badge}
            </p>
          </div>
        </Reveal>
        <div className="order-1 lg:order-2">
          <Reveal>
            <Eyebrow light>{t.eyebrow}</Eyebrow>
            <h2 className="font-display mt-5 text-4xl font-extrabold leading-[1] tracking-tight text-[#FDFBF7] sm:text-5xl">
              {t.title[0]} <span className="italic text-[#F26D5A]">{t.title[1]}</span>
            </h2>
          </Reveal>
          <div className="mt-12">
            {t.items.map((s, i) => <Step key={i} s={s} i={i} />)}
          </div>
        </div>
      </div>
    </section>
  );
};
